<pcg-table
    #table
    class="card-table"
    [ajaxData]="{ userId: id }"
    [pcgSort]="[['dateAttempted', 'desc']]"
    dataSource="api/Administration/Users/GetLoginHistoryList"
    [columnDefs]="columns"
>
    <ng-container matColumnDef="dateAttempted">
        <th
            mat-header-cell
            [pcg-sort-header]="'dateAttempted'"
            *matHeaderCellDef
        >
            {{ columns.get('dateAttempted').displayName }}
        </th>
        <td
            mat-cell
            *matCellDef="let row"
            [attr.data-label]="columns.get('dateAttempted').displayName"
        >
            {{ row.dateAttemptedFormatted }}
        </td>
    </ng-container>

    <ng-container matColumnDef="attemptSuccessful">
        <th
            mat-header-cell
            [pcg-sort-header]="'attemptSuccessful'"
            *matHeaderCellDef
        >
            {{ columns.get('attemptSuccessful').displayName }}
        </th>
        <td
            mat-cell
            *matCellDef="let row"
            [attr.data-label]="columns.get('attemptSuccessful').displayName"
        >
            {{ row.attemptSuccessful }}
        </td>
    </ng-container>

    <ng-container matColumnDef="userName">
        <th
            mat-header-cell
            [pcg-sort-header]="'userName'"
            *matHeaderCellDef
        >
            {{ columns.get('userName').displayName }}
        </th>
        <td
            mat-cell
            *matCellDef="let row"
            [attr.data-label]="columns.get('userName').displayName"
        >
            {{ row.userName }}
        </td>
    </ng-container>

    <ng-container matColumnDef="ipAddress">
        <th
            mat-header-cell
            [pcg-sort-header]="'ipAddress'"
            *matHeaderCellDef
        >
            {{ columns.get('ipAddress').displayName }}
        </th>
        <td
            mat-cell
            *matCellDef="let row"
            [attr.data-label]="columns.get('ipAddress').displayName"
        >
            {{ row.ipAddress }}
        </td>
    </ng-container>
</pcg-table>
